export const getFileName = function(callback, name) {
    return callback(`./${ name }`);
}